/**
 * SPA page-view tracker. Mounted once at the App root so every route change
 * sends a GA4 page_view (the gtag.js stub only auto-tracks the initial load).
 *
 * The first pathname after mount is intentionally skipped:
 *   - If consent was already granted on a previous visit, CookieBanner.tsx
 *     primes the first page_view itself on mount.
 *   - If consent isn't granted yet, analytics.trackPageView() is a no-op
 *     anyway, so the skip is harmless.
 */
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { analytics } from '@/lib/analytics';

export function AnalyticsRouteTracker() {
  const { pathname } = useLocation();
  const firstRender = useRef(true);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    analytics.trackPageView(pathname);
  }, [pathname]);

  return null;
}

export default AnalyticsRouteTracker;
